import { Api, IApiResponse } from '../api';
import { MyProfilesDto, ProfileDto } from '../models';

const getAll = (signal?: AbortSignal): Promise<IApiResponse<ProfileDto[]>> => Api.get('Profiles', signal);

const getMine = (signal?: AbortSignal, accessToken?: string): Promise<IApiResponse<MyProfilesDto>> => Api.get('Profiles/me', signal, accessToken);

export { getAll, getMine };
